// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3684Y","footer":"styles_footer__3rCmt","passCodeTooltip":"styles_passCodeTooltip__3SEXa"};